import variables from './variables';

export default {
  ...variables,
};
